/**
 * 참가자 종류가 저작하는 해석 코드 — 레지스트리(participantKinds)의 데이터 부분(트랙 A-4).
 *
 * 픽커·새 모델 다이얼로그는 "어느 코드가 지원되는가"만 필요한데, 레지스트리 파일은 파서·덱 출처·검증 같은
 * 무거운 바인딩을 정적으로 가져와 진입 청크에 MARS·Modelica 도메인이 실렸다(실측 §5). 그래서 코드 선언을
 * 여기(도메인 의존 없음)에 두고, 레지스트리는 종류별 바인딩을 이 선언에 **참조로** 붙인다.
 * 두 선언이 어긋나지 않게 participantKinds.test.ts 가 정체성(===)과 양방향 완비를 핀한다.
 */
export const PARTICIPANT_AUTHORING_CODES = {
  mars: ['MARS'],
  fmu: ['Modelica'],
} as const satisfies Record<string, readonly string[]>;

export type AuthoringKind = keyof typeof PARTICIPANT_AUTHORING_CODES;

/** 이 코드를 저작하는 종류가 등록돼 있는가 (미등록 코드 = "지원 예정") */
export function isAnalysisCodeSupported(code: string): boolean {
  return Object.values(PARTICIPANT_AUTHORING_CODES).some((codes) => (codes as readonly string[]).includes(code));
}
